// extracted by mini-css-extract-plugin
export var button = "button-module--button--14iy5";
export var degenesis = "button-module--degenesis--4nOVw";
export var white = "button-module--white--3AyCE";
export var green = "button-module--green--1kHGa";
export var small = "button-module--small--3wJah";